"use strict";

exports.__esModule = true;
exports.DeviceMetricColorSource = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Metrics = require("../../../../Catalogs/Metrics");
var _API = require("../../../API");
var _Measures = require("../../../Measures");
var _Time = require("../../../Time");
var _Metrics2 = require("../../../Metrics");
var _MetricValueBatchContext = require("../../../Widgets/MetricValue/MetricValueBatchContext");
var _dec, _dec2, _class, _DeviceMetricColorSource;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Metric driven device color source.
 * Supplies a color to children via a render prop.
 */
var DeviceMetricColorSource = exports.DeviceMetricColorSource = (_dec = _Time.TimeContext.withContext, _dec2 = _Time.ReportingPeriodContext.withContext, _dec(_class = _dec2(_class = (_DeviceMetricColorSource = /*#__PURE__*/function (_Component) {
  function DeviceMetricColorSource() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceMetricColorSource, _Component);
  var _proto = DeviceMetricColorSource.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      realtime = _this$props.realtime,
      deviceUuid = _this$props.deviceUuid,
      metric = _this$props.metric,
      thresholds = _this$props.thresholds,
      defaultColor = _this$props.defaultColor,
      children = _this$props.children,
      reportingPeriod = _this$props.reportingPeriod,
      time = _this$props.time;
    var interval = reportingPeriod && reportingPeriod.interval;
    var workday = time && time.currentWorkday && time.currentWorkday.interval;
    var shift = time && time.currentShift && time.currentShift.interval;
    var live = !!(workday && shift && interval && (0, _Metrics.canSubscribeToRealtime)(workday, shift, interval));
    if (realtime || live) {
      return /*#__PURE__*/_react["default"].createElement(_API.RealtimeDataSubscription, {
        params: ["metric", {
          entity: {
            device: deviceUuid,
            name: metric.name,
            period: reportingPeriod && reportingPeriod.name === "shift" ? "shift" : "workday"
          }
        }]
      }, function (packet) {
        var value = packet ? packet.value : null;
        var color = value == null ? defaultColor : (0, _Measures.getThresholdColor)(thresholds, metric.units === "FRACTIONAL_PERCENT" ? value * 100 : value);
        return children(color);
      });
    }
    var batch = this.context;
    if (batch && metric && interval && batch.isCovered(deviceUuid, metric.name, interval)) {
      var value = batch.isLoading(deviceUuid, metric.name, interval) ? null : batch.getValue(deviceUuid, metric.name, interval);
      var color = value == null ? defaultColor : (0, _Measures.getThresholdColor)(thresholds, value * 100);
      return children(color);
    }
    return /*#__PURE__*/_react["default"].createElement(_Metrics2.MetricQueryController, {
      query: {
        filters: {
          must: [{
            filterType: "range",
            fieldName: "timestamp",
            values: {
              gte: new Date(reportingPeriod.interval.startMillis).toISOString(),
              lt: new Date(reportingPeriod.interval.endMillis).toISOString()
            }
          }, {
            filterType: "term",
            fieldName: "device_id",
            values: deviceUuid
          }],
          mustNot: []
        },
        bins: [{
          binName: "by_device",
          fieldName: "device_id",
          aggType: "terms",
          options: {}
        }],
        metrics: [metric.name]
      }
    }, function (_ref) {
      var data = _ref.data;
      var value = data && Array.isArray(data.by_device) && data.by_device.length > 0 ? data.by_device[0].value : null;
      var color = value == null ? defaultColor : (0, _Measures.getThresholdColor)(thresholds, value * 100);
      return children(color);
    });
  };
  return DeviceMetricColorSource;
}(_react.Component), _DeviceMetricColorSource.contextType = _MetricValueBatchContext.MetricValueBatchContext, _DeviceMetricColorSource.defaultProps = {
  realtime: true,
  reportingPeriod: undefined,
  time: undefined
}, _DeviceMetricColorSource)) || _class) || _class);